import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import './SearchPoolStackedBar.css';

export type SearchPoolData = {
  matches1200: number;
  matches12001500: number;
  matches15001800: number;
  matches1800: number;
  uniqueSeeders: number;
};

type PropTypes = {
  searchPoolData: SearchPoolData;
  totalMatches: number;
};

export const SearchPoolStackedBar = ({
  searchPoolData,
  totalMatches,
}: PropTypes) => {
  return (
    <Box sx={{ color: '#B0E0E6' }}>
      <Box component="div" className="chart">
        <Tooltip
          title={`Total games in this MMR range: ${searchPoolData.matches1200}`}
          placement="top"
        >
          <Box
            component="span"
            className="block"
            sx={{
              width: `${(searchPoolData.matches1200 / totalMatches) * 100}%`,
            }}
          >
            <Box component="span" className="value" width={'100%'}>
              <Typography
                lineHeight={0}
                fontWeight={600}
                textAlign={'center'}
                color="black"
              >{`< 1200`}</Typography>
            </Box>
          </Box>
        </Tooltip>
        <Tooltip
          title={`Total games in this MMR range: ${searchPoolData.matches12001500}`}
          placement="top"
        >
          <Box
            component="span"
            className="block"
            sx={{
              width: `${
                (searchPoolData.matches12001500 / totalMatches) * 100
              }%`,
            }}
          >
            <Box component="span" className="value" width={'100%'}>
              <Typography
                lineHeight={0}
                fontWeight={600}
                textAlign={'center'}
                color="black"
              >{`1200 - 1500`}</Typography>
            </Box>
          </Box>
        </Tooltip>
        <Tooltip
          title={`Total games in this MMR range: ${searchPoolData.matches15001800}`}
          placement="top"
        >
          <Box
            component="span"
            className="block"
            sx={{
              width: `${
                (searchPoolData.matches15001800 / totalMatches) * 100
              }%`,
            }}
          >
            <Box component="span" className="value" width={'100%'}>
              <Typography
                lineHeight={0}
                fontWeight={600}
                textAlign={'center'}
                color="black"
              >{`1500 - 1800`}</Typography>
            </Box>
          </Box>
        </Tooltip>
        <Tooltip
          title={`Total games in this MMR range: ${searchPoolData.matches1800}`}
          placement="top"
        >
          <Box
            component="span"
            className="block"
            sx={{
              width: `${(searchPoolData.matches1800 / totalMatches) * 100}%`,
            }}
          >
            <Box component="span" className="value" width={'100%'}>
              <Typography
                lineHeight={0}
                fontWeight={600}
                textAlign={'center'}
                color="black"
              >{`> 1800`}</Typography>
            </Box>
          </Box>
        </Tooltip>
      </Box>
    </Box>
  );
};
